import { capitalize } from "lodash";

/** A product term in the forms copy needs, so renaming it is one edit. */
export type Noun = {
  singular: string;
  plural: string;
  /** Capitalized, for the start of a label or heading. */
  Singular: string;
  Plural: string;
  /** The singular with its article, such as "a project". */
  withArticle: string;
  WithArticle: string;
};

export function noun(singular: string, plural: string): Noun {
  return {
    singular,
    plural,
    Singular: capitalize(singular),
    Plural: capitalize(plural),
    withArticle: `a ${singular}`,
    WithArticle: `A ${singular}`,
  };
}
